import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { createSelector, select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { SelectOptionI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { State } from '../../reducers';
import { getOneClickSelectedProduct } from '../../selectors/one-click-products.selector';
import { getOneClickPreloadedOrder } from '../../selectors/one-click-profiles.selector';
import { getOneClickUnits } from '../../selectors/one-click-units.selector';
import { OneClickBuilderField } from '../../util/constants/builder-fields';
import { tonUnitConverter } from '@ordersnproducts/modules/shared/utils/api-data-correction';
import { FieldConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';

const defaultProductUnit = (index: number) =>
  createSelector(
    getOneClickUnits,
    getOneClickSelectedProduct(index),
    getOneClickPreloadedOrder,
    (units, productSelected, preloadedOrder) => {
      const defaultUnit = units.find((unit) => unit.alternativeUnit.unitId === productSelected.unitOfMeasure.unitId);
      return { defaultUnit, preloadedOrder };
    },
  );

@Injectable()
export class OneClickDefaultUnitsLoaderService implements SelectOptionLoaderI {
  constructor(private store: Store<State>) {}

  loadOptions(formGroup: UntypedFormGroup, config?: FieldConfig): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(defaultProductUnit(config['at'])),
      filter(({ defaultUnit }) => !!defaultUnit),
      map(({ defaultUnit, preloadedOrder }) => {
        formGroup.controls[OneClickBuilderField.Unit].disable();
        if (preloadedOrder) {
          defaultUnit && formGroup.controls[OneClickBuilderField.Unit].setValue(defaultUnit.alternativeUnit.unitId);
        } else {
          defaultUnit && formGroup.controls[OneClickBuilderField.Unit].setValue(defaultUnit.alternativeUnit.unitId);
        }

        return [
          {
            id: defaultUnit.alternativeUnit.unitId,
            name: tonUnitConverter(defaultUnit.alternativeUnit.unitCode),
          },
        ];
      }),
    );
  }
}
